module.exports = __webpack_public_path__ + "static/media/mr.a10b5559.svg";